<template>
  <div id="app">
<!--照片輪播 一次二張每張重複二次-->
<v-carousel
    cycle
    continuous 
    interval =5000
    :height="mainHeight"
    hide-delimiters
    eager
    > 
  <template v-for="index in photocounts"> 
    <v-carousel-item 
      :key="index"
      > 
      <v-row class="flex-nowrap" style="height:100%"> 
        <template v-for="i in 2"> 
          <template> 
            <v-col :key="i" > 
              <v-layout fill-height align-center>
              <v-img
               :src="index+i-2>photocounts-1? require(`../assets/home/` + photos[0]) : require(`../assets/home/` + photos[index+i-2])"
               :max-width='imgMaxWidth'
               :max-height="300"
               :width='imgWidth'
               :aspect-ratio="imgRatio"
               contain
              >
              </v-img></v-layout>
            </v-col> 
          </template> 
        </template> 
      </v-row> 
    </v-carousel-item> 
  </template> 
</v-carousel>  
  
  </div>
</template>

<script>

export default {
  name: 'HomePage',
  mounted() {
    this.resize();
    window.addEventListener('resize', this.resize);
  },
  data() {
    return {
      mainHeight: window.innerHeight-300,
      imgMaxWidth: window.innerWidth*0.4,
      imgWidth: this.imgMaxWidth,
      imgRatio: 16/9,
      photocounts: 43,
      photos: ["photo1.jpg",
          "photo2.jpg",
          "photo4.jpg",
          "photo5.jpg",
          "156234_0.jpg",
          "156235_0.jpg",
          "156238_0.jpg",
          "156243.jpg",
          "LINE_ALBUM_0914親職講座_230918_65.jpg",
          "LINE_ALBUM_0914親職講座_230918_80.jpg",
          "LINE_ALBUM_0914親職講座_230918_85.jpg",
          "LINE_ALBUM_0914親職講座_230918_88.jpg",
          "LINE_ALBUM_0914親職講座_230918_92.jpg",
          "LINE_ALBUM_2023.07.19 新生有約座談會_231023_16.jpg",
          "LINE_ALBUM_2023.07.19 新生有約座談會_231023_18.jpg",
          "LINE_ALBUM_2023.07.19 新生有約座談會_231023_34.jpg",
          "LINE_ALBUM_2023.07.19 新生有約座談會_231023_4.jpg",
          "LINE_ALBUM_2023.07.19 新生有約座談會_231023_6.jpg",
          "LINE_ALBUM_20230919消防、地震演習_230920_112.jpg",
          "LINE_ALBUM_20230919消防、地震演習_230920_16.jpg",
          "LINE_ALBUM_20230919消防、地震演習_230920_23.jpg",
          "LINE_ALBUM_20230919消防、地震演習_230920_38.jpg",
          "LINE_ALBUM_20230919消防、地震演習_230920_96.jpg",
          "S__933898_0.jpg",
          "S__933900_0.jpg",
          "S__933901_0.jpg",
          "S__933902_0.jpg",
          "S__933903_0.jpg",
          "S__933905_0.jpg",
          "S__933906_0.jpg",
          "S__933907_0.jpg",
          "S__933908_0.jpg",
          "S__933909_0.jpg",
          "S__933911_0.jpg",
          "S__933912_0.jpg",
          "S__933915_0.jpg",
          "S__933919_0.jpg",
          "S__933920_0.jpg",
          "S__933922_0.jpg",
          "S__933923_0.jpg",
          "S__933925_0.jpg",
          "S__933926_0.jpg",
          "S__933929_0.jpg"],
    };
  },
   methods: {
    resize() {
      this.imgMaxWidth= window.innerWidth*0.4;
      if(this.imgMaxWidth < 400) {
         this.imgMaxWidth = 400;
         this.imgWidth = 400;
      }
       
    },
  }
};
</script>

<style scoped>
.v-data-table::v-deep td {
    font-size: 18px !important;
}
@media (max-width:768px) {
.v-data-table::v-deep td {
    font-size: 16px !important;
}
}
</style>
